import { useEffect } from 'react';

import { useAtom } from 'jotai';

import useBeforeunload from 'src/hooks/useBeforeunload';
import { recentMatchCountAtom } from 'src/stores/match/atoms';

let ws: WebSocket | void;

const useSocketMatchCount = () => {
  const [recentMatchCount, setRecentMatchCount] = useAtom(recentMatchCountAtom);

  useBeforeunload(() => ws?.close());
  useEffect(() => {
    if (!ws) {
      ws = new WebSocket(process.env.NEXT_PUBLIC_MATCH_COUNT_API_ORIGIN + '/10m' || '');
    }
    const onMessage = (e: MessageEvent<number>) => {
      setRecentMatchCount(e.data);
    };
    ws.addEventListener('message', onMessage);
    return () => {
      ws?.removeEventListener('message', onMessage);
    };
  }, [setRecentMatchCount]);
  return recentMatchCount;
};

export default useSocketMatchCount;
